





















































declare var window: any;
import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { RecruiterRequest } from '../models/referrals/recruiterrequest';
import { RecruiterResponse } from '../models/referrals/recruiterresponse';
import { ReferFriendRequest } from '../models/referrals/referfriendreqest';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import { ModelListSelect } from 'vue-search-select';
import { Recruiter } from '../models/referrals/recruiter';
import FormCard from './ReferAFriend/FormCard.vue';
import SectionContainer from './Commons/SectionContainer.vue';
import SectionTitle from './Commons/SectionTitle.vue';
import UserForm from './ReferAFriend/UserForm.vue';
import FormSection from './ReferAFriend/FormSection.vue';
import SubmitButton from './ReferAFriend/SubmitButton.vue';
import UserFormValidator from './ReferAFriend/userFormValidator';
import MailClientOpener from '@/components/ReferAFriend/mailClientOpener';
import RecruiterListUtility from './ReferAFriend/recruiterListUtility';
import { mixins } from 'vue-class-component';
import GDPR from '@/components/Registration/GDPR.vue';
import { RecaptchaResponse } from '@/models/referrals/recaptchaResponse';
import ReCaptcha from './ReCaptcha/ReCaptcha.vue';

@Component({
  name: 'ReferAFriend',
  components: {
    ModelListSelect,
    FormCard,
    SectionTitle,
    SectionContainer,
    UserForm,
    SubmitButton,
    FormSection,
    GDPR,
    ReCaptcha
  },
})
export default class AnonReferAFriend extends mixins(
  UserFormValidator,
  MailClientOpener,
  RecruiterListUtility,
) {
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private recruiter: Recruiter = new Recruiter();
  private commonUserInfo: CommonUserInfo = new CommonUserInfo();
  private friendInfo: CommonUserInfo = new CommonUserInfo();
  private errorString: string = '';
  private searchText: string = '';
  private successString: string = '';
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  private recaptchaSizeValue: string = vxm.utility.isVisibleReCaptcha
    ? 'normal'
    : 'invisible';
  
  $wlToastr: any;

  get canShowReferralBonusMessage() {
    return !vxm.configs.getGlobalConfigBooelanValue('DISABLE_REFERRAL_BONUS_INFO_IN_REFERRAL_PAGE')
  }

  get getReferFriendTitle() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED')
      ? this.$t('referafriendexternal.title')
      : this.$t('referafriend.title');
  }

  get supportedFileSize() {
    return vxm.utility.fileUploadMaxSize
  }
  get recaptchaValue(): boolean {
    return this.showRecaptcha ? vxm.referrals.RecaptchaResponse.success : true;
  }
  get showRecaptcha(): boolean {
    return vxm.utility.showSignUpReCaptcha;
  }
  onRecaptchaExpired() {
    vxm.referrals.setRecaptchaResponse(new RecaptchaResponse());
  }
  sendAnonReferFriendRequest() {
    let validationMessage;
    validationMessage = this.formValidator(this.friendInfo);
    if (validationMessage) {
      this.$wlToastr('error', validationMessage, 'Friend Info');
      return;
    }
    if(this.friendInfo.mobile==null && this.friendInfo.phoneNumber.length>0){
      this.friendInfo.phoneNumber = ''
    }
    validationMessage = this.formValidator(this.commonUserInfo);
    if (validationMessage) {
      this.$wlToastr('error', validationMessage, 'Your Info');
      return;
    }
    if(this.commonUserInfo.mobile==null && this.commonUserInfo.phoneNumber.length>0){
      this.commonUserInfo.phoneNumber = ''
    }
    if (
      this.friendInfo.email === this.commonUserInfo.email ||
      
      ((this.friendInfo.phoneNumber.length>0 &&  this.commonUserInfo.phoneNumber.length>0)&& this.friendInfo.phoneNumber === this.commonUserInfo.phoneNumber) 
    ) {
      this.$wlToastr('error', this.$t('quicksignup-details-same-referrer'), '');
      return;
    }
    if (this.friendInfo.resumeFile && this.friendInfo.resumeFile.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', {maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return ;
    }
    if (!this.recaptchaValue){
      return this.$wlToastr('error', this.$t('jobshare.enter.recaptcha.response'), this.$t('myreferrals.jobreferral'));
    }
    let referFriendRequest: ReferFriendRequest = new ReferFriendRequest();
    this.commonUserInfo.recruiterName = this.recruiter.recruiterName;
    this.commonUserInfo.recruiterEmail = this.recruiter.recruiterEmail;
    referFriendRequest.commonUserInfo = this.commonUserInfo;
    referFriendRequest.friendList.push(this.friendInfo);
    referFriendRequest.companyCode = vxm.jobs.BrandingInfo.companycode || '';
    delete referFriendRequest.sessionToken;

    const referrerDetail = JSON.stringify({
      email: this.commonUserInfo.email,
      firstName: this.commonUserInfo.firstName,
      lastName: this.commonUserInfo.lastName,
      phoneNumber: this.commonUserInfo.phoneNumber,
    })
    
    const friendDetail = JSON.stringify({
      email: this.friendInfo.email,
      firstName: this.friendInfo.firstName,
      lastName: this.friendInfo.lastName,
      phoneNumber: this.friendInfo.phoneNumber,
      additionalNote: this.friendInfo.additionalNote,
    })
    const payload = new FormData()
    payload.append('companyCode', vxm.jobs.BrandingInfo.companycode)
    payload.append('referrerDetail', referrerDetail)
    payload.append('friendDetail', friendDetail)
    payload.append('recruiterEmail', this.recruiter.recruiterEmail)
    payload.append('sourceChannelValue','Talent Portal');
    this.friendInfo.resumeFile && payload.append('friendsResume', this.friendInfo.resumeFile)
    if (vxm.utmtracker.utmTrackerId > 0) {
      payload.append('utmTrackerId', String(vxm.utmtracker.utmTrackerId));
    }
    console.log(payload)

    vxm.referrals.anonReferTheFriend(payload).then(() => {
      if (vxm.referrals.EmployeeReferralResponse.errorCode) {
        this.$wlToastr(
          'error',
          vxm.referrals.EmployeeReferralResponse.errorMessage,
          this.$t('ResumeDetails_UploadResume'),
        );
      } else {
        vxm.users.Rudderstack.trackEvent("Referral Anonymous", {
          referralType: "Anon Refer a friend",
      recruiterId : this.recruiter.recruiterId
    })
        this.$wlToastr(
          'success',
          this.$t('referafriend.form.submit.success.message.without.bonus'),
        );
       
        this.mailClientOpener(this.friendInfo.email);
        
        this.friendInfo = new CommonUserInfo();
        this.commonUserInfo = new CommonUserInfo();
        referFriendRequest = new ReferFriendRequest();
        this.recruiter = new Recruiter();
        this.recruiterResponse = new RecruiterResponse();
      }
    });
  }

  get isAutomateEmails(){
  return vxm.configs.getGlobalConfigValue('WL_AUTOMATE_REFERRAL_EMAILS');
}
  printSearchText(searchText: string, initCall = false) {
    this.recruiterRequest.searchString = searchText;
    this.recruiterRequest.company = vxm.jobs.BrandingInfo.companycode;
    if (
      (searchText.trim().length >= 3 && !this.autoPopulateRecruiterList) ||
      (initCall && this.autoPopulateRecruiterList)
    ) {
      this.recruiterRequest.pageNumber = initCall ? -1 : 1;
      this.recruiterRequest.pageSize = initCall ? 50 : 5;
      vxm.referrals
        .getAnonRecruiterListByCompany(this.recruiterRequest)
        .then(() => {
          if (vxm.referrals.RecruiterResponse.recruiterList !== null) {
            this.recruiterResponse = vxm.referrals.RecruiterResponse;
          }
          
        });
    }
  }

  async mounted() {
    vxm.referrals.setRecaptchaResponse(new RecaptchaResponse());
    if (this.autoPopulateRecruiterList) {
      this.printSearchText('', true);
    }
  }

  get isGDPREnabled () {
    return vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
  }
  
  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
  }

  
  get isSubmittDisabled() {

    if (this.isGDPREnabled && (!this.gdprObj.tosEmailFlag || !this.gdprObj.marketingEmailFlag)) {
      return true;
    } else if (this.isGDPREnabled && (this.gdprObj.tosEmailFlag || this.gdprObj.marketingEmailFlag)) {
      false;
    }
    return false;
  }


}
